export default class Info {
  constructor (imageUrl, thumbnail, imageAlt, headline, content, id) {
    this.imageUrl = imageUrl
    this.thumbnail = thumbnail
    this.imageAlt = imageAlt
    this.headline = headline
    this.content = content
    this._id = id
  }

  get id () {
    return this._id || this.headline.split(' ')[0]
  }
}
